import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initializeFeatureFlags } from '@/shared/featureFlags/featureFlags'
import { logger } from '@/shared/logging/logger'

// Import main styles
import '@/shared/styles/app.scss'
import '@/shared/styles/common.scss'

// Create and mount the Vue application
const app = createApp(App)
app.use(router)

// Start Harness FME (Split) SDK initialization before initial component render
initializeFeatureFlags('anonymous')
  .catch((error) => {
    logger.error('Feature flags initialization failed.', error)
  })

app.mount('#app')
